import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { pbColors } from "./generic/genericTypes";

const HorizontalChart = ({ horizontalCharts }) => {
  const [HCData, setHCData] = useState([]);

  const demoData = [
    {
      name: "Currency",
      data: [33],
      color: pbColors.Currency,
    },

    {
      name: "FNO",
      data: [33],
      color: pbColors.FNO,
    },
    {
      name: "Equity",
      data: [33],
      color: pbColors.Equity,
    },
  ];

  useEffect(() => {
    console.log("horizontalCharts==>", horizontalCharts);
    if (horizontalCharts && horizontalCharts.length > 0) {
      let getDta = [];
      let isDataGrater = false;
      let reverseData = [...horizontalCharts];
      reverseData.reverse();
      reverseData.forEach((data) => {
        if (!isDataGrater && data.percent > 0) {
          isDataGrater = true;
        }
        getDta.push({
          name: data.name,
          data: [data.percent],
          color: data.color,
        });
      });
      if (getDta.length > 0) {
        if (!isDataGrater) {
          setHCData(demoData);
        } else {
          setHCData(getDta);
        }
      }
    } else {
      setHCData([]);
    }
  }, [horizontalCharts]);

  const options = {
    chart: {
      type: "bar",
      height: "40",
      // reflow: true,
      spacingRight: 0,
      marginRight: 0,
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        groupPadding: 0,
        pointPadding: 0,
        borderRadius: 10,
        dataLabels: {
          enabled: false,
        },
      },
      series: {
        stacking: "normal",
        pointPadding: 0,
        groupPadding: 0,
        showInLegend: false,
      },
      column: {
        borderRadius: "10px",
        groupPadding: 0,
        pointPadding: 0,
      },
    },
    tooltip: {
      formatter: function () {
        return `<b><span style="color:${this.series.color}">${this.series.name}</span> : ${this.y}%</b>`;
      },
      borderWidth: 0,
      backgroundColor: "#fff",
      borderRadius: 4,
    },

    xAxis: {
      lineWidth: 0,
      title: null,
      minorGridLineWidth: 0,
      lineColor: "transparent",
      minorTickLength: 0,
      tickLength: 0,
      gridLineColor: "transparent",
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
      tickWidth: 0,
      minPadding: 0,
      maxPadding: 0,
    },
    yAxis: {
      lineWidth: 0,
      minorGridLineWidth: 0,
      lineColor: "transparent",
      title: null,
      labels: {
        enabled: false,
      },
      minorTickLength: 0,
      tickLength: 0,
      gridLineColor: "transparent",
    },
    series: HCData.length > 0 ? [...HCData] : demoData,
  };

  return (
    <div className="HighChartContainer">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default HorizontalChart;
